module.exports = __webpack_public_path__ + "static/media/notification-sound.a90b8d5c.mp3";